/**
 * Common utility functions
 * @module utils
 */

/**
 * Debounces a function call
 * @param {Function} func - Function to debounce
 * @param {number} wait - Milliseconds to wait
 * @returns {Function} Debounced function
 */
export const debounce = (func, wait) => {
  let timeout;
  return function executedFunction(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
};

/**
 * Validates if a string is a valid URL
 * @param {string} href - URL to validate
 * @returns {boolean} Whether URL is valid
 */
export const isValidURL = (href) => {
  try {
    new URL(href);
    return true;
  } catch {
    return false;
  }
};
